import React, { useCallback, useEffect } from "react";
import {
    Form,
    Select,
    Modal,
    Typography,
    DatePicker,
    notification,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import StockLevelApi from "../../Apis/StockLevelApi";
import ProductionApi from "../../Apis/ProductionApi";
import StockApi from "../../Apis/StockApi";
import ProductApi from "../../Apis/ProductApi";
const { Title } = Typography;
function StockLevel({ visible, onClose, afterCookId, StockLevelProducts, StockLevelIncreadiant }) {
    const [formAdd] = Form.useForm();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

    formAdd.setFieldsValue({
        unitOfMeasurement: afterCookId?.unit,
        qtyInStock: afterCookId?.quantity,
        costOfStock: afterCookId?.productionCoast,
    });

    const getProductionWaste = useCallback(() => {

        ProductionApi.SingleProductionHistory(afterCookId?.batchCode)
            .then((response) => {
                let totalQuantity = 0;

                if (response?.payload?.productionWasteDTOList.length > 0) {
                    totalQuantity = response?.payload?.productionWasteDTOList.reduce((acc, curr) => acc + curr.quantity, 0);

                }
                formAdd.setFieldsValue({
                    waste: totalQuantity,
                    actualStock: parseFloat(afterCookId?.quantity) - parseFloat(totalQuantity),
                });;
            })
            .catch((err) => {
                console.log(err);
            });
    }, [afterCookId?.batchCode]);


    useEffect(() => {
        getProductionWaste();
    }, [getProductionWaste]);


    if (StockLevelProducts) {
        formAdd.setFieldsValue({
            qtyInStock: StockLevelProducts?.qtyInStock,
            actualStock: StockLevelProducts?.qtyInStock,
        });
    }

    const handleSubmit = (data) => {

        const verifiedBy = dayjs(data.verifiedBy).format("DD/MM/YYYY");
        const editedBy = dayjs(data.editedBy).format("DD/MM/YYYY");
        let formData = JSON.stringify({
            unitOfMeasurement: data.unitOfMeasurement,
            waste: 0,
            qtyInStock: data.qtyInStock,
            costOfStock: data.costOfStock,
            actualStock: data.actualStock,
            verifiedBy: verifiedBy,
            editedBy: editedBy,

            productionDTO: {
                id: afterCookId?.id,
                institutionDTO: {
                    id: afterCookId?.institutionDTO?.id,
                },
            },
            institutionDTO: {
                id: afterCookId?.institutionDTO?.id,
            },
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
        });
        StockLevelApi.CreateStockLevel(formData)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Created</span>,
                    description: "Created Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            })
            .catch((err) => {
                console.log(err);
                // Error Notification
                if (err.apiError.status) {
                    notification.open({
                        message: (
                            <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                        ),
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });

    };

    const currentDate = moment().format("DD/MM/YYYY");

    const isExpired = (expiryDate) => {
    if (!expiryDate) return false;

    const expiry = moment(parseInt(expiryDate, 10));
    const today = moment();

    return expiry.isBefore(today, "day");
};

    function formatDate(date) {
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString(
            "en-US",
            options
        );

        const [month, day, year] = formattedDate?.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }
    const handleCancel = () => {
        formAdd.resetFields();
        onClose();
    };


    const [StockListProduct, setStockListProduct] = React.useState(null);
    const [StockListError, setStockListError] = React.useState(null);
    const [SingleProduct, setSingleProduct] = React.useState(null);
   
    const handleChangeProduct = (value) => {
    setStockListProduct(null);
    ProductApi.SingleProducts(value).then((response2) => {
        setSingleProduct(response2?.payload);
        
        // Extract the code from productCode
        const productCode = response2?.payload?.productCode;
        let extractedCode = '';
        
        if (productCode) {
            if (productCode.includes('#')) {
                extractedCode = productCode.split('#').pop();
            } else {
                extractedCode = productCode.replace(/[^0-9]/g, '');
            }
            
            console.log('Extracted Code:', extractedCode);
            
            ProductApi.GetByBarCode(extractedCode)
                .then((barCodeResponse) => {
                    console.log('GetByBarCode Response:', barCodeResponse);
                    
                    const payloadDto = barCodeResponse?.payloadDto || [];
                    
                    if (payloadDto.length > 0) {
                        const formatNumber = (value) => {
                            if (!value) return 0;
                            const num = parseFloat(value);
                            if (isNaN(num)) return 0;
                            return Math.round(num * 100) / 100;
                        };
                        
                        // Get all product IDs from the response
                        const productIds = payloadDto.map(item => item.id);
                        console.log('Product IDs to fetch stock for:', productIds);
                        
                        // Fetch stock for each product ID individually
                        const stockPromises = productIds.map((productId) => {
                            return StockApi.ListStockProduct(productId)
                                .then((response) => {
                                    return {
                                        productId: productId,
                                        success: true,
                                        data: response?.payload || []
                                    };
                                })
                                .catch((err) => {
                                    console.error(`Stock API failed for product ${productId}:`, err);
                                    return {
                                        productId: productId,
                                        success: false,
                                        error: err?.apiError?.message || 'Stock not found',
                                        data: []
                                    };
                                });
                        });
                        
                        // Wait for all stock API calls to complete
                        Promise.all(stockPromises)
                            .then((stockResults) => {
                                console.log('All stock results:', stockResults);
                                
                                // Create a map of productId to stock data
                                const stockDataMap = {};
                                stockResults.forEach(result => {
                                    if (result.success && result.data.length > 0) {
                                        // Filter stock data (uom1 >= 0.01)
                                        const filteredData = result.data.filter(item => {
                                            const uom1 = parseFloat(item.unitOfMeasurement1);
                                            return uom1 >= 0.01;
                                        });
                                        stockDataMap[result.productId] = filteredData;
                                    } else {
                                        stockDataMap[result.productId] = [];
                                    }
                                });
                                
                                console.log('Stock data map:', stockDataMap);
                                
                                // Combine barCode data with stock data
                                const combinedData = [];

                                    payloadDto.forEach((item) => {

                                        const stockItems = stockDataMap[item.id] || [];

                                        if (stockItems.length > 0) {

                                            stockItems.forEach((stockItem) => {

                                                combinedData.push({
                                                    id: stockItem.id,

                                                    invoiceNumber: stockItem.invoiceNumber || `INV-${stockItem.id}`,

                                                    batchCode: stockItem.batchCode || item.productCode,

                                                    expiryDate: stockItem.expiryDate || stockItem.openUBD,

                                                    unitOfMeasurement1: formatNumber(
                                                        stockItem.unitOfMeasurement1
                                                    ),

                                                    unitOfMeasurement2: formatNumber(
                                                        stockItem.unitOfMeasurement1
                                                    ),

                                                    unit: stockItem.unit || item.unitUomTwo || item.unitUomOne || "KG",

                                                    productName: item.productName,

                                                    costPrice: formatNumber(
                                                        item.costPriceUoM2 || item.costPriceUoM1
                                                    ),

                                                    currency: item.currency || "€",

                                                    qtyInStock: formatNumber(
                                                        stockItem.unitOfMeasurement1
                                                    ),

                                                    actualStock: formatNumber(
                                                        stockItem.unitOfMeasurement1
                                                    ),

                                                    costOfStock: formatNumber(
                                                        stockItem.unitOfMeasurement1 *
                                                        (item.costPriceUoM2 || 0)
                                                    ),

                                                    hasStockData:true,

                                                    originalBarCodeData:item,

                                                    stockData:stockItem
                                                });

                                            });

                                        } else {

                                            combinedData.push({
                                                id:item.id,
                                                invoiceNumber:`INV-${item.id}`,
                                                batchCode:item.productCode,
                                                expiryDate:null,
                                                unitOfMeasurement1:0,
                                                unitOfMeasurement2:0,
                                                unit:item.unitUomTwo || item.unitUomOne,
                                                productName:item.productName,
                                                costPrice:item.costPriceUoM2 || 0,
                                                currency:item.currency || "€",
                                                qtyInStock:0,
                                                actualStock:0,
                                                costOfStock:0,
                                                hasStockData:false,
                                                originalBarCodeData:item,
                                                stockData:null
                                            });

                                        }

                                    });
                                
                                const failedIds = stockResults
                                    .filter(result => !result.success)
                                    .map(result => result.productId);
                                    
                                if (failedIds.length > 0) {
                                    console.log(`Stock API failed for product IDs: ${failedIds.join(', ')}`);
                                    notification.warning({
                                        message: 'Partial Data',
                                        description: `Stock data not available for some products (IDs: ${failedIds.join(', ')})`,
                                        duration: 5
                                    });
                                }
                                
                                setStockListProduct(combinedData);
                                setStockListError(null);
                                
                                console.log('Final Combined Data:', combinedData);
                            })
                            .catch((err) => {
                                console.error('Error processing stock data:', err);
                                setStockListError('Error fetching stock data');
                            });
                    } else {
                        setStockListProduct([]);
                        setStockListError('No products found for this barcode');
                    }
                })
                .catch((err) => {
                    console.error('GetByBarCode Error:', err);
                    setStockListError(err?.apiError?.message || 'Error fetching product by barcode');
                    setStockListProduct([]);
                });
        } else {
            setStockListProduct([]);
            setStockListError('No product code found');
        }
    })
    .catch((err) => {
        console.error('SingleProducts Error:', err);
        setStockListError(err?.apiError?.message || 'Error fetching product');
    });
};
    return (
        <>
            <Modal
                footer={[]}
                width={800}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Stock Level
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        <div className="Product-createDate">
                            <div className="" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b className="mx-2">{currentDate}</b>
                                <img
                                    src="/assest/Images/cal.png"
                                    style={{ width: '32px' }}
                                    className="logo-png"
                                />
                            </div>
                            <Form.Item
                                name="createDate"
                                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                                className="text-lable col-lg-6 col-sm-12 col-md-7 d-none"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter Date.",
                                    },
                                ]}
                            >
                                <DatePicker
                                    format={"DD/MM/YYYY"}
                                    className="form-control control-input"
                                />
                            </Form.Item>
                        </div>
                        <Form.Item
                            name="productId"
                            label="Product :"
                            className="text-lable pt-3 disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Product.",
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                className="control-Select mb-1"
                                placeholder="Select Product"
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(value) => handleChangeProduct(value)}

                                allowClear
                            >
                                {StockLevelIncreadiant.map((option, index) => (
                                    <Select.Option key={option.id} value={option?.productDTO?.id}>
                                        {option.name}
                                    </Select.Option>
                                ))}

                            </Select>
                        </Form.Item>
                        {StockListError &&
                            <p style={{ color: 'red', textAlign: 'end' }}>{StockListError}</p>
                        }
                        <div className="dateFilterTable">
                            <table className="table users-table" >
                                <thead>
                                    <tr style={{ verticalAlign: 'top' }}>
                                        <th>Invoice #</th>
                                        <th >Batch Code</th>
                                        <th className="text-center" >OUBD<br /> <p className="mb-0 pb-0" style={{ color: 'gray', fontSize: '12px' }}>(Original Used by Date)</p></th>
                                        <th className="text-center">Qty(UOM1)</th>
                                        <th >Qty(UOM2)</th>
                                        <th className="text-end">Cost (UOM2)</th>
                                    </tr>
                                </thead>
                                <tbody className={StockListProduct?.length > 6 ? 'tableScroll' : ''}>
                                    {StockListProduct
                                        ?.filter(item => parseFloat(item?.unitOfMeasurement1 || 0) > 0)
                                        .map((item, index) => (
                                        <>
                                            <tr
                                                style={{
                                                    cursor: 'pointer',
                                                    backgroundColor: isExpired(item?.expiryDate) ? '#ffcccc' : 'transparent'
                                                }}
                                            >

                                                <td className="CleanTable px-2 text-start PnameClass" style={{ width: '10%', textAlign: 'start' }} >
                                                    {item?.invoiceNumber}
                                                </td >
                                                <td className="CleanTable text-start PnameClass">                                         
                                                    <div style={{
                                                        overflowX: 'auto',
                                                        overflowY: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        maxWidth: '200px',
                                                        marginBottom: '10px',
                                                        marginTop: '-3px',
                                                        padding: '0px 0px 20px',
                                                        display: 'block',
                                                    }}>
                                                        {item?.batchCode || '-'}
                                                    </div>
                                                </td>
                                                <td className="CleanTable px-2 PnameClass text-center" style={{ width: '10%', textAlign: 'start' }} >
                                                    {formatDate(item?.expiryDate)}
                                                </td >
                                                <td style={{ width: '10%', textAlign: 'end' }} className="CleanTable PnameClass" >
                                                    {(parseFloat(item?.unitOfMeasurement1) / parseFloat(SingleProduct?.unitOfMeasurement2 || 1)).toFixed(2)} {SingleProduct?.unitUomOne}
                                                </td >
                                                <td style={{ width: '10%', textAlign: 'end' }} className="CleanTable PnameClass" >
                                                    {parseFloat(item?.unitOfMeasurement1).toFixed(2)} {item?.unit}
                                                </td >
                                                <td style={{ width: "10%", textAlign: 'end' }} className="CleanTable PnameClass" >
                                                    {SingleProduct?.currency + ((parseFloat(item?.unitOfMeasurement1)) * (SingleProduct?.costPriceUoM2)).toFixed(2)}
                                                </td>
                                            </tr >
                                        </>
                                    ))}

                                </tbody>

                            </table>
                        </div>

                        {/* <div className="row">
                            <div className="col-4"></div>
                            <div className="col-6" style={{ paddingLeft: "30px" }}>
                                <Link to={"/production"} target="_blank">
                                    <u>Create New Production</u>
                                </Link>
                            </div>
                        </div> */}
                        {/* <Form.Item
                            name="unitOfMeasurement"
                            label="Unit Of Measurement"
                            className="text-lable  disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Product.",
                                },
                            ]}
                        >
                            <Select
                                disabled
                                className="control-Select mb-1"
                                placeholder="Select Unit"
                            >
                                <option value="Kg"> Kg</option>
                                <option value="G"> G</option>
                                <option value="L"> L</option>
                                <option value="ML"> ML</option>
                                <option value="BOX"> BOX</option>
                                <option value="PACKET"> PACKET</option>
                                <option value="PIECE"> PIECE</option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="waste"
                            label="waste"
                            className="text-lable pt-3"
                        >
                            <Input
                                type="text"
                                onChange={(e) =>
                                    handleWaste(
                                        e.target.value
                                    )
                                }
                                placeholder="Waste"
                                className="control-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="qtyInStock"
                            label="Quantity In Stock"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Product.",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                disabled
                                placeholder="Quantity In Stock"
                                className="control-input"
                            />
                        </Form.Item>

                        <Form.Item
                            name="costOfStock"
                            label="Cost of Stock"
                            className="text-lable disabled"
                        >
                            <Input
                                type="text"
                                disabled
                                placeholder="Cost of Stock"
                                className="control-input"
                            />
                        </Form.Item>

                        <Form.Item
                            name="actualStock"
                            label="Actual Stock"
                            className="text-lable disabled"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Product.",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                disabled
                                placeholder="Actual Stock"
                                className="control-input"
                            />
                        </Form.Item> */}

                        {/* <Form.Item
                            name="OUBD"
                            label="OUBD"
                            className="text-lable"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select OUBD.",
                                },
                            ]}
                        >
                            <DatePicker
                                format={"DD/MM/YYYY"}
                                className="form-control control-input"
                            />
                        </Form.Item> */}
                        {/* <Form.Item
                            name="verifiedBy"
                            label="Verified By"
                            className="text-lable "
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Verified Date",
                                },
                            ]}
                        >
                            <DatePicker
                                format={"DD/MM/YYYY"}
                                className="form-control control-input"
                            />
                        </Form.Item>
                        <Form.Item
                            name="editedBy"
                            label="Edited By"
                            className="text-lable "
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Edited Date",
                                },
                            ]}
                        >
                            <DatePicker
                                format={"DD/MM/YYYY"}
                                className="form-control control-input"
                            />
                        </Form.Item> */}





                        {/* <div className="d-flex justify-content-center pt-4">
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled
                                className="btn btn-primary btn-save mx-2"
                                style={{ width: "37%" }}
                            >
                                Create
                            </Button>
                            <Link
                                type="primary"
                                to={""}
                                className="btn btn-primary btn-back mx-2 w-20"
                                style={{ width: "37%" }}
                                onClick={handleCancel}
                            >
                                Cancel
                            </Link>
                        </div> */}
                    </>
                </Form>
            </Modal >
        </>
    );
}

export default StockLevel;
